import React from 'react';
import PropTypes from 'prop-types';
import { UiIcon } from 'ui-components';

export function CountryFilterSelectedList({
  countries,
  selectedIds,
  onRemove,
}) {
  return (
    <div className='selected-tags'>
      <div className='tags flex'>
        {countries
          .filter((c) => selectedIds.includes(c.id))
          .map(({ id, name }) => (
            <span key={id} className='tag flex'>
              <span>{name}</span>
              <UiIcon
                icon='ri-close-line'
                className='icon'
                onClick={() => onRemove(id)}
              />
            </span>
          ))}
      </div>
    </div>
  );
}

CountryFilterSelectedList.propTypes = {
  countries: PropTypes.array,
  selectedIds: PropTypes.array,
  onRemove: PropTypes.func,
};
